<template>
  <el-container style="width:100%;">
    <el-header>
      <el-row type="flex" :gutter="10">
        <el-col style="line-height: 60px;" :span="2">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
        </el-col>
        <el-col style="line-height: 60px;" :span="6">
          <el-button
            round
            @click="exportMemberData"
          >{{ generateCustomizeString('batchExportMemberInfo') }}</el-button>
        </el-col>
        <el-col style="line-height: 60px;">
          <el-select
            style="width: 300px;"
            size="mini"
            v-model="selectCoupon"
            :placeholder="generateCustomizeString('selectCoupon')"
          >
            <el-option
              v-for="item in couponOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button
            @click="sendCoupon"
            size="mini"
            style="margin-left: 10px;"
          >{{generateCustomizeString('sendCoupon')}}</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col>
          <el-form
            :inline="true"
            ref="searchForm"
            :model="searchForm"
            class="search-form-inline"
            size="mini"
          >
            <el-form-item :label="generateCustomizeString('memberId')">
              <el-input
                v-model="searchForm.user_id"
                :placeholder="generateCustomizeString('memberId')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('phoneNumber')">
              <el-input
                v-model="searchForm.phone"
                :placeholder="generateCustomizeString('phoneNumber')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('email')">
              <el-input
                v-model="searchForm.email"
                :placeholder="generateCustomizeString('email')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('wechatName')">
              <el-input
                v-model="searchForm.wx_nickname"
                :placeholder="generateCustomizeString('wechatName')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('customerRemark')">
              <el-input
                v-model="searchForm.remark"
                :placeholder="generateCustomizeString('customerRemark')"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-form
          :inline="true"
          ref="searchForm"
          :model="searchForm"
          class="search-form-inline"
          size="mini"
        >
          <el-form-item :label="generateCustomizeString('registrationDateRange')">
            <el-date-picker
              v-model="searchForm.datetimeRange"
              type="datetimerange"
              :picker-options="datetimeRangePickerOptions"
              range-separator="-"
              :start-placeholder="generateCustomizeString('start')"
              :end-placeholder="generateCustomizeString('end')"
              :default-time="['00:00:00', '23:59:59']"
              align="right"
              style="width: 460px;"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row>
        <el-col>
          <el-form
            :inline="true"
            ref="searchForm"
            :model="searchForm"
            class="search-form-inline"
            size="mini"
          >
            <el-form-item :label="generateCustomizeString('memberLevel')">
              <el-select
                v-model="searchForm.level"
                :placeholder="generateCustomizeString('memberLevel')"
              >
              <template v-if="$i18n.locale == 'zh'">
                <el-option
                  v-for="item in memberOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </template>
              <template v-if="$i18n.locale == 'en'">
                <el-option
                  v-for="item in memberOptions"
                  :key="item.value"
                  :label="item.enName"
                  :value="item.value"
                ></el-option>
              </template>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="searchForm.isOrderByOrderSum"
                  :label="generateCustomizeString('sortByTotalOrderSum')"
                  border
                ></el-checkbox>
              </el-form-item>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">{{generateCustomizeString('search')}}</el-button>
              <el-button @click="onReset">{{generateCustomizeString('reset')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="memberData"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom:60px;"
        v-loading.body="memberListLoading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column :label="generateCustomizeString('wechatInfo')">
          <el-table-column :label="generateCustomizeString('wechatImg')">
            <template slot-scope="scope">
              <img
                v-if="scope.row.wechat_headimgurl.length > 0"
                :src="scope.row.wechat_headimgurl"
                style="width:auto;height:50px;"
              />
              <span v-else>N.A</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('wechatNickname')" width="150">
            <template slot-scope="scope">
              <span>{{scope.row.wechat_nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('wechatSex')">
            <template slot-scope="scope">
              <span>{{scope.row.wechat_sex}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('country')">
            <template slot-scope="scope">
              <span>{{scope.row.wechat_country}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('province')">
            <template slot-scope="scope">
              <span>{{scope.row.wechat_province}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('city')">
            <template slot-scope="scope">
              <span>{{scope.row.wechat_city}}</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column :label="generateCustomizeString('miniProgramInfo')">
          <el-table-column :label="generateCustomizeString('wechatImg')">
            <template slot-scope="scope">
              <img
                v-if="scope.row.wechat_mini_auths && scope.row.wechat_mini_auths.headimgurl"
                :src="scope.row.wechat_mini_auths.headimgurl"
                style="width:auto;height:50px;"
              />
              <span v-else>N.A</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('wechatNickname')" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.wechat_mini_auths && scope.row.wechat_mini_auths.nickname">
                {{scope.row.wechat_mini_auths.nickname}}
              </span>
              <span v-else>N.A</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('wechatSex')">
            <template slot-scope="scope">
              <span v-if="scope.row.wechat_mini_auths && scope.row.wechat_mini_auths.sex">
                <span v-if="scope.row.wechat_mini_auths.sex === 1">{{ generateCustomizeString('wechatMale') }}</span>
                <span v-else-if="scope.row.wechat_mini_auths.sex === 2">{{ generateCustomizeString('wechatFemale') }}</span>
                <span v-else>{{ generateCustomizeString('wechatUnknown') }}</span>
              </span>
              <span v-else>N.A</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('country')">
            <template slot-scope="scope">
              <span v-if="scope.row.wechat_mini_auths && scope.row.wechat_mini_auths.country">
                {{scope.row.wechat_mini_auths.country}}
              </span>
              <span v-else>N.A</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('province')">
            <template slot-scope="scope">
              <span v-if="scope.row.wechat_mini_auths && scope.row.wechat_mini_auths.province">
                {{scope.row.wechat_mini_auths.province}}
              </span>
              <span v-else>N.A</span>
            </template>
          </el-table-column>
          <el-table-column :label="generateCustomizeString('city')">
            <template slot-scope="scope">
              <span v-if="scope.row.wechat_mini_auths && scope.row.wechat_mini_auths.city">
                {{scope.row.wechat_mini_auths.city}}
              </span>
              <span v-else>N.A</span>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column :label="generateCustomizeString('customerRemark')" width="190">
          <template slot-scope="scope">
            <span v-if="scope.row.remark">{{scope.row.remark}}</span>
            <span v-else>N.A</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" :label="generateCustomizeString('phone')" width="150">
          <template slot-scope="scope">
            <span>{{scope.row.phone}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" :label="generateCustomizeString('email')" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.email">
              <span>{{scope.row.email}}</span>
              <el-tooltip v-if="scope.row.email_verified_at"  effect="dark" :content="generateCustomizeString('emailIsVerified')" placement="top-start">
                <i class="el-icon-success email-verified"></i>
              </el-tooltip>
              <el-tooltip v-else class="item" effect="dark" :content="generateCustomizeString('emailIsNotVerified')" placement="top-start">
                <i class="el-icon-question email-not-verified"></i>
              </el-tooltip>
            </div>
            <div v-else>
              N.A
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="this.$i18n.locale == 'zh'"
          prop="level_name"
          :label="generateCustomizeString('memberLevel')"
          width="200"
        ></el-table-column>
        <el-table-column
          v-if="this.$i18n.locale == 'en'"
          prop="level_enName"
          :label="generateCustomizeString('memberLevel')"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="total_cost"
          :label="generateCustomizeString('totalAmount')"
          width="150"
        >
          <template slot-scope="scope">{{ scope.row.total_cost | formatPrice}}</template>
        </el-table-column>
        <el-table-column
          prop="credits"
          :label="generateCustomizeString('memberCredit')"
          width="150"
        >
          <template slot-scope="scope">{{ scope.row.credits | formatPrice}}</template>
        </el-table-column>
        <el-table-column
          prop="created_at"
          :label="generateCustomizeString('registrationDate')"
          width="160"
        >
          <template slot-scope="scope">
            <span>{{scope.row.created_at | toLocalTime}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="generateCustomizeString('operate')" width="70" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="viewClick(scope.row)"
              type="text"
              size="small"
            >{{generateCustomizeString('view')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfMembers"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
        <el-col>
          <div style="position: fixed; right: 30px;">
            <span style="font-size: 14px; color: #606266;">{{ generateCustomizeString('perPage') }}: </span>
            <el-select v-model="numOfMembers" style="width: 100px;" @change="selectNumOfMembers()">
              <el-option
                v-for="item in numOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import dayjs from 'dayjs'
import XLSX from 'xlsx'
import XLSX_SAVE from 'file-saver'

const originMemberSearchFrom = {
  level: null,
  user_id: '',
  phone: '',
  email: '',
  wx_nickname: '',
  remark: '',
  datetimeRange: [],
  isOrderByOrderSum: false
}

const emptyMemberItem = {
  id: '',
  phone: 'N.A',
  email: 'N.A',
  level_name: 'N.A',
  total_cost: 0,
  credits: 0,
  created_at: '',
  remark: 'N.A',
  wechat_headimgurl: '',
  wechat_nickname: 'N.A',
  wechat_country: 'N.A',
  wechat_province: 'N.A',
  wechat_city: 'N.A',
  wechat_sex: 'N.A'
}

export default {
  name: 'MemberCenter',
  components: {},
  data() {
    return {
      isShowExportExcel: false,
      memberData: [],
      memberListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      numOfMembers: 15,
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        },
        {
          value: 1000,
          label: '1000'
        }
      ],
      datetimeRangePickerOptions: {
        shortcuts: [
          {
            text: this.generateCustomizeString('lastWeek'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'week')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastMonth'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(1, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          },
          {
            text: this.generateCustomizeString('lastThreeMonths'),
            onClick(picker) {
              const end = dayjs().endOf('day')
              const start = end
                .clone()
                .subtract(3, 'month')
                .startOf('day')
              picker.$emit('pick', [start.toDate(), end.toDate()])
            }
          }
        ]
      },
      searchForm: Object.assign({}, originMemberSearchFrom),
      memberOptions: [],
      multipleSelection: [],
      selectCoupon: '',
      selections: [],
      couponOptions: []
    }
  },
  methods: {
    generateCustomizeString,
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(val)
    },
    selectNumOfMembers() {
      this.fetchMemberData(1)
    },
    onSearch() {
      this.$refs.searchForm.validate(valid => {
        if (valid) {
          this.fetchMemberData(1)
        } else {
          console.log('data error')
        }
      })
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.searchForm = JSON.parse(JSON.stringify(originMemberSearchFrom))
      this.fetchMemberData(1)
    },
    onRefersh() {
      this.fetchMemberData(this.currentPage)
    },
    exportMemberData() {
      if (this.multipleSelection.length === 0) {
        this.$alert(
          this.generateCustomizeString('pleaseSelectMembers'),
          this.generateCustomizeString('warning'),
          {
            confirmButtonText: this.generateCustomizeString('confirm'),
            callback: action => {}
          }
        )
        return
      }
      const exportData = this.multipleSelection.map(selection => {
        const item = {
          ID: selection.id,
          微信昵称: selection.wechat_nickname,
          性别: selection.wechat_sex,
          国家: selection.wechat_country,
          省份: selection.wechat_province,
          城市: selection.wechat_city,
          电话: 'Tel: ' + selection.phone,
          会员等级: selection.level_name,
          总消费: this.$options.filters.formatPrice(selection.total_cost),
          余额: this.$options.filters.formatPrice(selection.credits),
          注册时间: this.$options.filters.toLocalTime(selection.created_at),
          备注: selection.remark
        }
        return item
      })

      this.downloadFile(exportData)
    },
    changeDialogVisible(flag) {
      this.isShowExportExcel = flag
    },
    viewClick(row) {
      this.$router.push({
        name: 'MemberView',
        params: { memberId: row.id }
      })
    },
    handleCurrentChange(val) {
      this.fetchMemberData(val)
    },
    fetchCoupons() {
      return new Promise((resolve, reject) => {
        request({
          url: 'coupon/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].title
              data[i] = obj
            }
            this.couponOptions = data
            console.log(this.couponOptions)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    sendCoupon() {
      this.selections = this.$refs.multipleTable.selection
      if (this.selections.length === 0) {
        this.$message.info(this.generateCustomizeString('pleaseChooseMembers'))
        return
      }
      const selectIds = []
      for (var i = 0; i < this.selections.length; i++) {
        selectIds.push(this.selections[i].id)
      }

      request({
        url: 'coupon/batch/send',
        method: 'post',
        data: {
          customer_ids: selectIds,
          coupon_id: this.selectCoupon
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('couponBatchIssued'),
              type: 'success'
            })
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message({
            message: this.generateCustomizeString('couponBatchIssueFailed'),
            type: 'error'
          })
        })
    },
    fetchAllLevels() {
      return new Promise((resolve, reject) => {
        request({
          url: 'discount/level/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].level
              obj.label = response.data[i].name
              data[i] = obj
            }
            this.memberOptions = data
            for (var i = 0; i < this.memberOptions.length; i++) {
              switch (this.memberOptions[i].label) {
                case '青铜':
                  this.memberOptions[i].enName = this.generateCustomizeString('青铜')
                  break
                case '白银':
                  this.memberOptions[i].enName = this.generateCustomizeString('白银')
                  break
                case '黄金':
                  this.memberOptions[i].enName = this.generateCustomizeString('黄金')
                  break
                case '铂金':
                  this.memberOptions[i].enName = this.generateCustomizeString('铂金')
                  break
                case '钻石':
                  this.memberOptions[i].enName = this.generateCustomizeString('钻石')
                  break
                case '星耀':
                  this.memberOptions[i].enName = this.generateCustomizeString('星耀')
                  break
                case '王者':
                  this.memberOptions[i].enName = this.generateCustomizeString('王者')
                  break
                default:
                  this.memberOptions[i].enName = this.memberOptions[i].label
              }
            }
            console.log(this.memberOptions)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchMemberData(page) {
      this.memberData = []
      this.memberListLoading = true
      return new Promise((resolve, reject) => {
        const params = {
          page: page,
          ...this.searchForm,
          page_size: this.numOfMembers
        }

        if (
          this.searchForm.datetimeRange &&
          this.searchForm.datetimeRange.length === 2
        ) {
          const dates = this.searchForm.datetimeRange.map(date =>
            dayjs(date)
              .utc()
              .format('YYYY-MM-DD HH:mm:ss')
          )
          params.start_created_at = dates[0]
          params.end_created_at = dates[1]
          delete params.datetimeRange
        }

        if (this.searchForm.isOrderByOrderSum) {
          params['order_by'] = 'total_cost'
        }
        delete params.isOrderByOrderSum

        request({
          url: '/customer-list',
          method: 'get',
          params: params
        })
          .then(response => {
            for (let i = 0; i < response.data.length; i++) {
              const item = JSON.parse(JSON.stringify(emptyMemberItem))
              item.id = response.data[i].id
              item.created_at = response.data[i].created_at
              if (response.data[i].phone) {
                item.phone = response.data[i].phone
              }
              item.total_cost = response.data[i].total_cost
              if (response.data[i].remark) {
                item.remark = response.data[i].remark
              }
              if (
                response.data[i].points &&
                response.data[i].points.level_info
              ) {
                item.level_name = response.data[i].points.level_info.name
                switch (item.level_name) {
                  case '青铜':
                    item.level_enName = this.generateCustomizeString('青铜')
                    break
                  case '白银':
                    item.level_enName = this.generateCustomizeString('白银')
                    break
                  case '黄金':
                    item.level_enName = this.generateCustomizeString('黄金')
                    break
                  case '铂金':
                    item.level_enName = this.generateCustomizeString('铂金')
                    break
                  case '钻石':
                    item.level_enName = this.generateCustomizeString('钻石')
                    break
                  case '星耀':
                    item.level_enName = this.generateCustomizeString('星耀')
                    break
                  case '王者':
                    item.level_enName = this.generateCustomizeString('王者')
                    break
                  default:
                    item.level_enName = item.level_name
                }
              }
              item.email = response.data[i].email

              item.email_verified_at = response.data[i].email_verified_at

              if (response.data[i].credits) {
                item.credits = response.data[i].credits.credits
              }
              if (
                response.data[i].wechat_auths.length &&
                response.data[i].wechat_auths[0].user_info
              ) {
                if (response.data[i].wechat_auths[0].user_info['headimgurl']) {
                  item.wechat_headimgurl =
                    response.data[i].wechat_auths[0].user_info['headimgurl']
                }
                if (response.data[i].wechat_auths[0].user_info['nickname']) {
                  item.wechat_nickname =
                    response.data[i].wechat_auths[0].user_info['nickname']
                }
                if (response.data[i].wechat_auths[0].user_info['country']) {
                  item.wechat_country =
                    response.data[i].wechat_auths[0].user_info['country']
                }
                if (response.data[i].wechat_auths[0].user_info['province']) {
                  item.wechat_province =
                    response.data[i].wechat_auths[0].user_info['province']
                }
                if (response.data[i].wechat_auths[0].user_info['city']) {
                  item.wechat_city =
                    response.data[i].wechat_auths[0].user_info['city']
                }
                if (response.data[i].wechat_auths[0].user_info['sex']) {
                  if (response.data[i].wechat_auths[0].user_info['sex'] === 1) {
                    item.wechat_sex = this.generateCustomizeString('wechatMale')
                  } else if (
                    response.data[i].wechat_auths[0].user_info['sex'] === 2
                  ) {
                    item.wechat_sex = this.generateCustomizeString(
                      'wechatFemale'
                    )
                  } else {
                    item.wechat_sex = this.generateCustomizeString(
                      'wechatUnknown'
                    )
                  }
                }
              }
              if (
                response.data[i].wechat_mini_auths.length &&
                response.data[i].wechat_mini_auths[0].user_info
              ) {
                item.wechat_mini_auths = response.data[i].wechat_mini_auths[0].user_info
              }

              this.memberData.push(item)
            }
            this.currentPage = response.meta.current_page
            this.currentTotal = response.meta.total
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
          .finally(() => {
            this.memberListLoading = false
          })
      })
    },
    downloadFile: function(data) {
      const fileName = dayjs()
        .local()
        .format('YYYY-MM-DD_HH-mm-ss')

      /* make the worksheet */
      var ws = null
      ws = XLSX.utils.json_to_sheet(data, {
        skipHeader: false
      })

      /* write workbook (use type 'binary') */
      var csv = XLSX.utils.sheet_to_csv(ws)

      /* prepend UTF-8 BOM */
      const str = '\ufeff' + csv

      /* force a download */
      XLSX_SAVE.saveAs(
        new Blob([str], { type: 'application/octet-stream' }),
        'Member_Data_' + fileName + '.csv'
      )
    }
  },
  created: function() {
    Promise.all([
      (this.memberListLoading = true),
      this.fetchAllLevels(),
      this.fetchCoupons()
    ])
      .then(result => {
        this.fetchMemberData(1)
      })
      .catch(error => {
        console.warn(error)
      })
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
}

.search-form-inline {
  // text-align: right;
  max-height: 60px;
  // padding-top: 10px;
}

.email-verified {
  color: #67C23A;
  padding: 0 !important;
}
.email-not-verified {
  color: #E6A23C;
  padding: 0 !important;
}
</style>
